import styled, { css } from 'styled-components'
import { Row } from '@sainsburys-tech/bolt'
import { createCSSObject, colorToLunaToken } from '../../../../helpers/theming/utilities'
import { TextWrapper } from '../../../../helpers/StyledWrappers.styles'
import { themeContract } from './M0041.theme.contract'
import { M0041StyledProps } from './types'

const wrapperCSS = css`
  min-height: 210px;
  width: 100%;
  align-items: center;
  justify-content: center;
  background-position: center center;
  background-size: cover;
  text-decoration: none;
  overflow: hidden;
  position: relative;

  ${(props) =>
    css`
      padding-top: ${props.theme.size.spacing.lg};
      margin-bottom: ${props.theme.size.spacing.lg};
      color: ${props.theme.color.monochrome.white};
      border-radius: ${props.theme.size.border.radius.base};
    `}
`

const StyledWrapper = styled(Row)`
  ${wrapperCSS}
`

const HeroImageBase = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

const StyledHeroImageWrapper = styled(HeroImageBase)<M0041StyledProps>`
  opacity: 0.8;
  z-index: 2;
  background-color: ${(props) =>
    colorToLunaToken(props.colorOverlay, props.theme) || props.theme.color.monochrome.darker};
`

const StyledHeroImage = styled(HeroImageBase)<M0041StyledProps>`
  background-size: cover;
  background-position: center;
  z-index: 1;
  width: 100%;

  ${(props) =>
    props.backgroundImage &&
    css`
      background-image: ${props.backgroundImage};
    `}
`

const StyledHeroBlurryImage = styled(StyledHeroImage)`
  z-index: 0;
`

const StyledHeroCopyWrapper = styled(Row)`
  ${TextWrapper}
  display: flex;
  max-width: 100%;
  overflow: hidden;
  z-index: 2;
  color: ${(props) => props.theme.color.monochrome.white};

  ${(props) => css`
    padding: 0 ${props.theme.size.spacing.lg};

    ${props.hasLegalCopy &&
    css`
      flex: 1;
    `}
  `}
`

const StyledHeroHeading = styled.h3`
  margin-top: auto;

  && {
    ${(props) => css`
      ${createCSSObject(props.theme.font.stack[themeContract[props.theme.channel].heading.mobileDisplay])}

      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        ${createCSSObject(props.theme.font.stack['display-2'])}
      }
    `}
  }
`

const StyledHeroVoucherCode = styled.p<M0041StyledProps>`
  && {
    ${(props) =>
      css`
        display: inline-block;
        background: ${props.theme.color.monochrome.white};
        padding: ${themeContract[props.theme.channel].voucher.verticalPadding / 2}px ${props.theme.size.spacing.lg};
        font-weight: ${props.theme.font.weight.bold};
        color: ${colorToLunaToken(props.colorOverlay, props.theme) || props.theme.color.monochrome.darker};
        border-radius: ${props.theme.size.border.radius.base};
        width: fit-content;
        ${props.alignment &&
        css`
          align-self: ${props.alignment};
        `}
      `}
  }
`
// TODO: Create new css object function.
const StyledLegalCopy = styled.p`
  ${(props) => css`
    ${createCSSObject(props.theme.font.stack.caption)}
    margin-top: auto;
  `}
`

export {
  StyledWrapper,
  StyledHeroImageWrapper,
  StyledHeroImage,
  StyledHeroBlurryImage,
  StyledHeroCopyWrapper,
  StyledHeroHeading,
  StyledHeroVoucherCode,
  StyledLegalCopy
}
